import CS from "./Common";

const validator = require("validator");

class Validation {
  onInput(type, e) {
    let value = e.target.value;
    switch (type) {
      case "number":
        value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
        break;
      case "eng&Number":
        value = value.replace(/[^a-z0-9]/gi, "");
        break;
      case "phone":
        value = value
          .replace(/[^0-9]/g, "")
          .replace(
            /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
            "$1-$2-$3"
          )
          .replace("--", "-");
        break;
      case "eng&Number&Hyphen":
        value = value.replace(/[^a-zA-Z0-9\-]/g, "");
        break;
      case "excludeKorean":
        value = value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, ""); // 한글 제거
        break;

      default:
        break;
    }
    e.target.value = value;
  }

  // 2024.08.23 특수문자 입력 방지
  characterCheck(e) {
    let value = e.target.value;
    var regExp = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
    value = value.replace(regExp, "");
    e.target.value = value;
  }

  

  isValidEmail(email) {
    if (!validator.isEmail(email)) {
      CS.notification("warning", "유효하지 않은 이메일 주소입니다.");
      return false;
    }
    return true;
  }

  isLengthValid({
    str,
    min = 0,
    max
  }) {
    console.log("isLengthValid", str, min, max, str.length);
    if (str.length < min || (max && str.length > max)) {
      return false;
    }
    return true;
  }

  isValidMobile(phone) {
    if (!validator.isMobilePhone(phone, "ko-KR", true)) {
      CS.notification("warning", "유효하지 않은 전화번호입니다.");
      return false;
    }
    return true;
  }

  isValidPasswd(passwd) {
    var regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{6,16}/;
    if (!regex.test(passwd)) {
      CS.notification(
        "warning",
        "비밀번호 형식이 올바르지 않습니다.\n 정규식 6-16자리 영문,숫자,특수문자 조합"
      );
      return false;
    }
    return true;
  }
}

export default new Validation();
